import {
  CUSTOMER_CARD_ADDED,
  CUSTOMER_CARD_ADDED_SUCCESS,
  CUSTOMER_CARD_ADDED_ERROR,
  GET_CUSTOMER_CARDS,
  GET_CUSTOMER_CARDS_SUCCESS,
  GET_CUSTOMER_CARDS_ERROR,
} from "./actionType";

const initialState = {
  loading: false,
  cardAddedSuccess: [],
  cardAddedError: [],
  customerCardsList: [],
};

const Charges = (state = initialState, action) => {
  switch (action.type) {
    case CUSTOMER_CARD_ADDED:
      return {
        ...state,
        loading: true,
      };
    case CUSTOMER_CARD_ADDED_SUCCESS:
      return {
        ...state,
        loading: false,
        cardAddedSuccess: action.payload,
      };
    case CUSTOMER_CARD_ADDED_ERROR:
      return {
        ...state,
        loading: false,
        cardAddedError: action.payload,
      };
    case GET_CUSTOMER_CARDS:
      return {
        ...state,
        loading: true,
      };
    case GET_CUSTOMER_CARDS_SUCCESS:
      return {
        ...state,
        loading: false,
        customerCardsList: action.payload,
      };
    case GET_CUSTOMER_CARDS_ERROR:
      return {
        ...state,
        loading: false,
        customerCardsList: action.payload,
      };

    default:
      return state;
  }
};
export default Charges;
